import { Button } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import Iconify from "../../../../minimals/components/iconify";
import { AddEditContactContext } from "../../contact/addEditContact/AddEditContactContext";

export default function GoBackButton({ customClickHandler }: { customClickHandler?: Function }) {
  const { reset, resetMergingContacts } = useContext(AddEditContactContext);
  const navigate = useNavigate();

  return (
    <Button
      variant="outlined"
      startIcon={<Iconify icon="eva:arrow-back-fill" />}
      onClick={() => {
        if (customClickHandler) {
          customClickHandler();
          return;
        }
        navigate(-1);
        reset();
        resetMergingContacts();
      }}
    >
      Go Back
    </Button>
  );
}
